module.exports = __webpack_public_path__ + "static/heat-3c57d0f7f7f161ac09ea92f3b8f9dc2e.png";